/**
 * `true` solo cuando `cargando` lleva más de `retardoMs` seguidos en `true`.
 *
 * Sirve para no mostrar un esqueleto (o la línea de progreso) en cargas rápidas: si los datos llegan
 * antes del retardo, se pasa directo al contenido sin parpadeo. Al terminar la carga vuelve a `false`
 * de inmediato.
 */
import { useEffect, useState } from 'react';

export const RETARDO_CARGA_MS = 300;

export function useMostrarTrasRetardo(cargando: boolean, retardoMs = RETARDO_CARGA_MS): boolean {
  const [vencido, setVencido] = useState(false);
  const [anterior, setAnterior] = useState(cargando);

  // Ajuste durante el render (no en un efecto): al cambiar `cargando` se olvida el plazo anterior.
  if (cargando !== anterior) {
    setAnterior(cargando);
    setVencido(false);
  }

  useEffect(() => {
    if (!cargando) return;
    const temporizador = window.setTimeout(() => setVencido(true), retardoMs);
    return () => window.clearTimeout(temporizador);
  }, [cargando, retardoMs]);

  return cargando && vencido;
}
